import Breadcrumbs from "@/components/common/Breadcrumbs";

const BreadcrumbLayout = ({ children = null }) => (
  <div className="flex flex-col gap-8 p-6 bg-white-subtle h-full w-full">
    <Breadcrumbs />
    <div className="w-full flex-grow">
      { children }
    </div>
  </div>
);

export default BreadcrumbLayout;
